import MuiModal, { type ModalProps } from "@mui/material/Modal";

export type { ModalProps };

export function Modal(props: ModalProps) {
  return <MuiModal {...props} />;
}
